import SearchRules from "../Rules/SearchRules";

const LeftHeader = () => (
  <div className="flex items-center justify-between px-4 pt-2 border-b bg-gray-50">
    <SearchRules />
  </div>
);

export default LeftHeader;